import { ApolloClient, HttpLink, from } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import type { Maybe } from '@custom/dx3';
import { stall } from '@custom/dx3';
import merge from 'lodash/merge';
import { AUTH_ENVIRONMENT } from '../utils/config/AUTH_ENVIRONMENT';
import { cache } from './cache/cache';

let savedToken: Maybe<string>;

export function setApolloToken(token: Maybe<string>) {
  savedToken = token;
}

const getUri = (operationName?: string) => {
  const opVar = operationName ? `?operationName=${operationName}` : '';
  const uri = `https://xfinitydle${
    AUTH_ENVIRONMENT === 'prod' ? '' : AUTH_ENVIRONMENT
  }.performnet.com/dle-api/graphql.biws`;
  return uri + opVar;
};

export const client = (function () {
  const errorLink = onError((error) => {
    if (error.graphQLErrors)
      error.graphQLErrors.forEach(({ message, locations, path }) =>
        console.error('[GraphQL error]:', { message, locations, path })
      );
    else if (error.networkError)
      console.error(`[Network error]: ${error.networkError}`);
    else console.error(error);
  });

  const operationNameLink = setContext((request) => {
    const uri = getUri(request.operationName);
    return { uri };
  });

  const authLink = setContext(async (_, previousContext) => {
    if (!savedToken) await stall(1);
    if (!savedToken) return previousContext;

    const auth = {
      headers: {
        Authorization: `Bearer ${savedToken}`,
      },
    };

    return merge(previousContext, auth);
  });

  const httpLink = new HttpLink();

  return new ApolloClient({
    cache,
    link: from([errorLink, operationNameLink, authLink, httpLink]),
    defaultOptions: {
      watchQuery: {
        errorPolicy: 'all',
      },
    },
  });
})();
